<template>
    <section :style="`background-color: ${backgroundColor};`">
        <div class="grid grid-cols-12">

            <div
                class="lg:col-span-7 col-span-12 2xl:ml-[calc((100vw_-_1280px)_/_2)] 2xl:px-32 px-6 md:px-16 lg:py-0 py-8">
                <div class="flex flex-col justify-center h-full xl:pl-36 xl:ml-2 xl:pr-0 2xl:pl-0">
                    <h2 class="text-2xl font-bold text-center md:text-3xl lg:text-3xl xl:text-40 xl:leading-10 font-ww-bold md:text-left">
                        {{ heading }}
                    </h2>
                    <div class="mt-4 text-base lg:mt-8 md:text-lg font-ww-regular !leading-5 md:text-left text-center" v-html="description"></div>
                </div>
            </div>

            <div class="col-span-12 lg:col-span-5">
                <nuxt-img :src="imageSrc" :alt="imageAlt"  width="1211" height="1305"
                    sizes="xs:330px sm:440px md:760px lg:1023px xl:493px 2xl:989px" loading="lazy" format="webp"
                    class="mx-auto" />
            </div>

      
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    heading: {
        type: String,
        default: "Chocolate Raspberry Truffle"
    },
    description: {
        type: String,
        default: `
       Flavors of royalty and sophistication provide an escape from the mundane, transforming your cup of coffee into an occasion of celebration as rich flavors of decadent and smooth chocolate mingle with heavenly sweet and slightly tart, ripe, red raspberries swirling amidst our beloved medium roast, premium quality, low acid, Arabica coffee beans. 
<br><br>
Enjoy a cup to celebrate special occasions or to transform the ordinary to the extravagant in a simple, yet sophisticated sip! 
      `
    },
    imageSrc: {
        type: String,
        default: "/assets/images/chocolate-covered.png"
    },
    imageAlt: {
        type: String,
        default: "Chocolate Covered Strawberry"
    },
    backgroundColor: {
        type: String,
        default: "#F4F2EE"
    }
});

defineBuilderComponent({
    friendlyName: "InfoWithFullRightImage",
    inputs: [
        {
            name: "heading",
            type: "string",
            friendlyName: "Heading",
            defaultValue: "Chocolate Raspberry Truffle"
        },
        {
            name: "description",
            type: "richText",
            friendlyName: "Description",
            defaultValue: `
        Flavors of royalty and sophistication provide an escape from the mundane, transforming your cup of coffee into an occasion of celebration as rich flavors of decadent and smooth chocolate mingle with heavenly sweet and slightly tart, ripe, red raspberries swirling amidst our beloved medium roast, premium quality, low acid, Arabica coffee beans. 
<br><br>
Enjoy a cup to celebrate special occasions or to transform the ordinary to the extravagant in a simple, yet sophisticated sip! 
        `
        },
        {
            name: "imageSrc",
            type: "file",
            friendlyName: "Image Source",
            allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
            defaultValue: "/assets/images/chocolate-covered.png"
        },
        {
            name: "imageAlt",
            type: "string",
            friendlyName: "Image Alt Text",
            defaultValue: "Chocolate Covered Strawberry"
        },
        {
            name: "backgroundColor",
            type: "color",
            friendlyName: "Background Color",
            defaultValue: "#F4F2EE"
        }
    ]
});
</script>